import { Injectable } from "@angular/core";
import { EventService } from "../event-service/event.service";

@Injectable()
export class SetFocusService {
  constructor(private eventService: EventService) {}

  public for(id: string) {
    return setTimeout(() => {
      this.eventService.publish("setFocusOn", id);
    });
  }
}
